<template>
  <div class='container'>
    <van-nav-bar fixed left-arrow @click-left="$router.back()" title="小智同学"></van-nav-bar>
    <!-- 聊天列表 -->
    <div class="chat-list" ref="list">
      <div class="chat-item" :class="{left:item.name==='xz',right:item.name==='self'}"  v-for="(item,i) in list" :key="i">
        <tt-icon v-if="item.name==='xz'" name="xiaozhi" />
        <div class="chat-pao">{{item.msg}}</div>
        <van-image v-if="item.name==='self'" fit="cover" round :src="photo" />
      </div>
    </div>
    <!-- 输入框 -->
    <div class="reply-container van-hairline--top">
      <van-field v-model.trim="value" left-icon="edit" placeholder="请描述您的问题"></van-field>
      <span class="send" @click="send()">发送</span>
    </div>
  </div>
</template>

<script>
// 1. webpcak img的静态src指定的本地图片 打包。
import zxAvatar from '../../assets/xz.png'
import { mapState } from 'vuex'
import io from 'socket.io-client'
import { baseURL } from '@/utils/request'
export default {
  name: 'UserChat',
  data () {
    return {
      // 输入框内容
      value: '',
      zxAvatar,
      // 聊天记录列表
      // 约定：小智 {name:'xz',msg:''} 自己 {name:'self',msg:''}
      list: [{ name: 'xz', msg: '你好' }, { name: 'self', msg: '呵呵呵' }],
      socketio: null
    }
  },
  computed: {
    ...mapState(['photo', 'user'])
  },
  created () {
    // 1. 建立连接
    this.socketio = io(baseURL, {
      query: {
        token: this.user.token
      },
      transports: ['websocket']
    })
    this.socketio.on('connect', () => {
      // 2. 连接成功
      // 让小智给你打个招呼
      this.list.push({ name: 'xz', msg: '您想知道点啥？' })
    })
    // 4. 收消息
    this.socketio.on('message', (data) => {
      // 聊天记录
      this.list.push({ name: 'xz', msg: data.msg })
      this.scrollBottom()
    })
  },
  beforeDestroy () {
    this.socketio.close()
  },
  methods: {
    send () {
      if (!this.value) return false
      // 3. 发信息
      this.socketio.emit('message', { msg: this.value, timestamp: Date.now() })
      // 聊天记录
      this.list.push({ name: 'self', msg: this.value })
      this.value = ''
      this.scrollBottom()
    },
    scrollBottom () {
      this.$nextTick(() => {
        this.$refs.list.scrollTop = this.$refs.list.scrollHeight // 可滚动的高度
      })
    }
  }
}
</script>

<style scoped lang='less'>
.container {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  background:#fff;
  padding: 46px 0 50px 0;
  .chat-list {
    height: 100%;
    overflow-y: scroll;
    .chat-item{
      padding: 10px;
      .van-image{
        vertical-align: middle;
        width: 40px;
        height: 40px;

      }
      .tt-icon {
        font-size: 40px;
        line-height: 0;
      }
      .chat-pao{
        vertical-align: top;
        display: inline-block;
        min-width: 40px;
        max-width: 70%;
        min-height: 40px;
        line-height: 20px;
        border-radius: 4px;
        position: relative;
        padding: 10px;
        background-color: #F7F8FA;
        word-break: break-all;
        font-size: 14px;
        color: #333;
        &::before{
          content: "";
          width: 6px;
          height: 6px;
          position: absolute;
          top: 15px;
          background: #F7F8FA;
        }
      }
    }
  }
}
.chat-item.right{
  text-align: right;
  .chat-pao{
    margin-left: 0;
    margin-right: 10px;
    &::before{
      right: -3px;
      transform: rotate(45deg);
    }
  }
}
.chat-item.left{
  text-align: left;
  .chat-pao{
    margin-left: 10px;
    margin-right: 0;
    &::before{
      left: -3px;
      transform: rotate(-135deg);
    }
  }
}
.reply-container {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 44px;
  width: 100%;
  background: #fff;
  z-index: 9999;
  display: flex;
  align-items: center;
  padding: 0 10px;
  > .van-field {
    flex: 1;
    background: #F7F8FA;
    height: 32px;
    border-radius: 16px;
    padding: 0 10px;
    line-height: 32px;
    ::v-deep .van-field__left-icon .van-icon {
      color: #ccc;
    }
  }
  > .send {
    margin-left: 10px;
    color: #999;
  }
}
</style>
